<dx-drop-down-button #dropdownButton id="filter-domain" [width]="width" [dropDownOptions]="dropDownOptions" stylingMode="contained">
  <div *dxTemplate="let data of 'item'" class="filter-button">
    <div class="filter-text">{{ filterName }}</div>
    <div class="filter-chip" *ngIf="selectedItems.length" [ngStyle]="{ background: chipColor }">
      {{ selectedItems.length }}
    </div>
    <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
  </div>
  <div *dxTemplate="let data of 'content'" class="filter-dropdown-content">
    <div class="filter-dropdown-title">Filter {{ filterName }}</div>
    <div class="filter-dropdown-list">
      <dx-list
        #list
        [dataSource]="items"
        [displayExpr]="displayExpr"
        [selectedItemKeys]="selectedItems"
        selectionMode="multiple"
        [searchEnabled]="true"
        [searchEditorOptions]="{ stylingMode: 'outlined', placeholder: searchPlaceholder, elementAttr: { class: 'filter-list-search' } }"
        [searchExpr]="displayExpr"
        searchMode="contains"
        pageLoadMode="scrollBottom"
        [keyExpr]="keyExpr"
        (onItemClick)="clickItem($event)"
      >
        <div *dxTemplate="let item of 'item'" class="filter-list-item">
          <div class="selection-controller" [ngStyle]="{ borderColor: item.color ?? chipColor }">
            <mat-icon fontIcon="check" [ngStyle]="{ backgroundColor: item.color ?? chipColor }"></mat-icon>
          </div>
          <span>{{ item.name }}</span>
        </div>
      </dx-list>
    </div>
  </div>
</dx-drop-down-button>
<div #popupContainer style="position: relative"></div>
